export default __webpack_public_path__ + "static/5-cc7a5e916264553127a05bea2e77a0ff.png";